import { useUserBranchLocations } from '../../hooks/useUserBranchLocations';
import { useUserSelectedBranchLocation } from '../../hooks/useUserSelectedBranchLocation';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import { useEffect, useState } from 'react';
import apiService from '../../axios/apiService';
import { useUser } from '../../hooks/useUser';
import { mapUserToClinic, mapUserToLocations } from '../../utils/mapper';
import { useUserClinic } from '../../hooks/useUserClinic';
import Loader from '../../common/loader.jsx';
const BranchLocationSelector = () => {
  const { locations, setBranchLocations } = useUserBranchLocations();
  const { selectBranchLocation } = useUserSelectedBranchLocation();
  const navigate = useNavigate();
  const { setUser } = useUser();
  const { setUserClinic } = useUserClinic();
  const [isLoading, setIsLoading] = useState(false);

  const setBranchLocation = (location) => {
    // Set state of newly selected branch location on the app
    selectBranchLocation(location);
    // Navigate to dashboard
    navigate('/user/admin-dashboard');
  };

  useEffect(() => {
    const refreshUserAndLocations = async () => {
      try {
        setIsLoading(true);
        const user = await apiService.callme();
        if (!user) return;

        // Persist user on local storage
        setUser(user);

        // Refresh branch locations on app state
        const branchLocations = mapUserToLocations(user);
        setBranchLocations(branchLocations);

        // Refresh clinic on app state (and localStorage "user_clinic")
        const clinic = mapUserToClinic(user);
        setUserClinic(clinic);
      } catch (e) {
        // ignore - selector page can still render using persisted state
      } finally {
        setIsLoading(false);
      }
    };

    refreshUserAndLocations();
  }, []);

  return (
    <>
      <Header />
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-8 col-sm-12 col-md-8 col-xl-8">
              <div className="card top-departments">
                <div className="card-header">
                  <h4 className="card-title mb-0">
                    {locations?.length === 0
                      ? 'You do not have any branch locations assigned to you or your branch has been disabled. Contact your admin for further assistance.'
                      : 'Select Clinic Location'}
                  </h4>
                </div>
                <div className="card-body">
                  {locations?.map((location) => (
                    <div key={location?.clinicLocationId}>
                      <div className="departments-list pb-4">
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <h4>{location?.title}</h4>
                            <p>{location?.address}</p>
                          </div>
                          <div>
                            <button
                              type="submit"
                              className="btn btn-primary"
                              onClick={() => setBranchLocation(location)}
                            >
                              Select
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <Loader />}
    </>
  );
};
export default BranchLocationSelector;
